import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLatters";
import projects from '../../data/projects.json'
import './index.scss'
import {AiOutlineGithub, AiOutlineProject} from 'react-icons/ai'
import Loader from "react-loaders";

export default function Projects(){
    const [letterClass,setLetterClass]=useState('text-animate')
    useEffect(()=>{
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    },[])
    return (
        <>
            <div className="project-page">
                <h1>
                    <span>
                        <AnimatedLetters strAry={'My '.split('')} letterClass={letterClass} idx={12}/>
                    </span>
                    <span>
                        <AnimatedLetters strAry={'Recent '.split('')} letterClass={letterClass} idx={13}/>
                    </span>
                    <span>
                        <AnimatedLetters strAry={'Projects'.split('')} letterClass={letterClass} idx={14}/>
                    </span>
                </h1>
                <div className="projects">
                    {projects.map((project,ind)=>{
                        return(
                            <div className="image-box" key={ind}>
                                <img className='project-image'  src={project.image} alt="not found" />
                                <div className="content">
                                    <p className="title">{project.title}</p>
                                    <h4 className="description">{project.description}</h4>
                                    <div className=" flex justify-evenly">
                                        <button className="btn" onClick={()=>window.open(project.demo)}>
                                            <AiOutlineProject size={20}/>
                                            Demo
                                        </button>
                                        <button className="btn" onClick={()=>window.open(project.git)}>
                                            <AiOutlineGithub size={20}/>
                                            Git
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Loader type="pacman"/>
        </>
    )
}